import { HttpBackend, HttpClient } from "@angular/common/http";
import { Component, HostListener, Inject, OnInit, Renderer2, ViewEncapsulation } from "@angular/core";
import { FormControl } from "@angular/forms";

import { DwComponent, DwComponentSectionConfigPreference, DwComponentType, DwExpressionService, DwMessagingService, DwMetaDataFormStateService, DwMetaDataService, DwMetaDataServiceToken, DwModalButtonStandardConfigs, DwModalConfig, DwModalService, DwModalSize, DwOrmDataService, DwOrmDataServiceToken, DwQueryHelper, DwSectionBaseComponent, DwSecurityRepositoryService, DwSecurityRepositoryServiceToken, DwSecurityUserService, DwUiConfigRegistryService, DwUIMetaDataConfig, DwUIMetaDataConfigToken } from '@devwareapps/devware-cap';
import { Config, ConfigService } from "src/environments/environment";
import { FileExplorerNewConfig } from "../models/file-explorer-new-config.model";
import { FileExplorerNewConfigComponent } from "./file-explorer-new-config/file-explorer-new-config.component";
import { AppMetaDataService } from 'src/app/meta-data/app-meta-data.service';
import { WachterUserExt } from 'src/app/shared/models/wachter-user.model';
import * as moment from 'moment';

import { AnimationOptions } from "ngx-lottie";
import { of, Subject } from "rxjs";
import { FileExplorerConfig } from "../../file-explorer/models/file-explorer-config.model";

//from OldFileExploerer that is good to use
import { Folder } from "../../file-explorer/models/folder";
import { NewFolderModelComponent } from "../../file-explorer/components/new-folder-model/new-folder-model.component";
import { UploadFileModalComponent } from "../../file-explorer/components/upload-file-modal/upload-file-modal.component";
import { FolderAPI } from "../../file-explorer/models/folderApi";
import { FileApi } from "../../file-explorer/models/fileApi";

@DwComponent({
    name: 'New FileExplorer',
    isGlobal: true,
    componentType: DwComponentType.formSection,
    configComponent: FileExplorerNewConfigComponent
})
@Component({
    encapsulation: ViewEncapsulation.None,
    selector: 'app-file-explorer-new',
    templateUrl: './file-explorer-new.component.html',
    styleUrls: ['./file-explorer-new.component.scss']
})
export class FileExplorerNewComponent extends DwSectionBaseComponent<DwComponentSectionConfigPreference<FileExplorerNewConfig>> implements OnInit
{
    folders : Folder[];
    selectedFolderId: number;
    files;
    moment: any = moment;
    public backgroundColor = '#fff';
    options: AnimationOptions = {
      path: '/assets/lottie/wachter_loading.json',
    };
    fileDropOptions: AnimationOptions = {
      path: '/assets/lottie/file_drop.json'
    }
    fileBeingDropped: boolean = false;
    loaded: boolean = false;
    trustUserId;

    FileExplorerConfig: FileExplorerConfig;

    http: HttpClient;

    attachmentObjectId;
    parrentAttachmentFolderId;

    eventsSubject: Subject<void> = new Subject<void>();
    searchQuery: string;

    constructor(private renderer:Renderer2,
        dwExpressionService: DwExpressionService,
        dwUiConfigRegistryService: DwUiConfigRegistryService,
        @Inject(DwUIMetaDataConfigToken) uiMetaDataConfig: DwUIMetaDataConfig,
        @Inject(DwMetaDataServiceToken) dwMetaDataService: DwMetaDataService,
        @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService,
        @Inject(DwMetaDataFormStateService) private dwMetaDataFormStateService: DwMetaDataFormStateService,
        private dwModalService: DwModalService,
        httpBackend: HttpBackend,
        private securityService: DwSecurityUserService,)
        {
            super(dwExpressionService, dwUiConfigRegistryService, uiMetaDataConfig, dwMetaDataService);
            this.http = new HttpClient(httpBackend);
        }

    ngOnInit(): void {
        super.ngOnInit();

        this.FileExplorerConfig = this.sectionConfig.config;

        this.attachmentObjectId = this.getAttachmentObjectId(this.FileExplorerConfig.attachmentId).value;
        this.getParentFolderId();
        this.delay(300).then(() => {
            if(this.attachmentObjectId == null)
            {
                //create attachmentObjectStructure.
            }
            this.getFolders(this.parrentAttachmentFolderId);
            const wachterUser = new WachterUserExt(this.securityService.securityContext.ApplicationUser);
            this.trustUserId = wachterUser.trustUserId;

        });

    }

    getAttachmentObjectId(attrName: string): FormControl {
        const md = new AppMetaDataService();

        return this.getOrCreateFormControl(attrName);
    }

    delay(ms: number)
    {
        return new Promise( resolve => setTimeout(resolve, ms));
    }

    getFolders(attachmentFolderId: number,)
    {
        let url = '';
        url = ConfigService.config.wAppsApi + 'api/v3/folder?folderId='+attachmentFolderId;
        this.folders = [];
        let folderSub = this.http.get(url);
        return folderSub.subscribe(results =>
        {
            let folderResults: FolderAPI[] = results as FolderAPI[];
            this.folders = folderResults;
        },
        errors => {
            //handle errors
        }
        );
    }
    getFiles(folderId: number)
    {
        let url = '';
        url = ConfigService.config.wAppsApi + 'api/v3/file?folderId='+folderId;
        var fileSub = this.http.get(url);
        this.files = [];
        fileSub.subscribe(results =>{
            let filesResult: FileApi[] = results as FileApi[]
            filesResult.forEach(file =>{
                this.getUser(file.CreatedBy).toPromise().then(user => {
                    this.files.push({FileId: file.AttachmentFileId, FileName: file.CurrentDisplay, FolderParent: file.AttachmentFolderId, selected: false, Size: file.Size, CreatedBy: user[0]['NameLastFirstPrefered'], CreatedDate: file.CreatedDateTime});
                    this.loaded = true;
                })
            });
        });
        this.loaded = true;
    }

    getUser(trustId)
    {
        const metaData = new AppMetaDataService();
        const queryHelper = new DwQueryHelper();
        const query = metaData.RoEthosUser.CreateQuery();
        query.AddFilterAnd(queryHelper.filters.Equal(metaData.RoEthosUser.UserId, trustId))
        const results = this.dataService.executeQuery(query);
        return results;
    }

    onRightClick(event)
    {
        return false;
    }

    onNewFolder()
    {
        let modalConfig = new DwModalConfig();

        const metaData = new AppMetaDataService();

        modalConfig.allowFullScreen = true;
        modalConfig.cloneData = false;
        modalConfig.modalSize = DwModalSize.responsive;
        modalConfig.data = {

        };
        modalConfig.component = NewFolderModelComponent;
        modalConfig.title = 'New Folder';
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.SaveAndClose;

        this.dwModalService.showModal(modalConfig).subscribe(result => {
            if(!result.cancelled)
            {
                this.createNewFolder(result.data, this.selectedFolderId, this.trustUserId);
            }
        });
    }

    createNewFolder(folderName, parentFolderId, trustUserId)
    {
        var data = {FolderName: folderName, ParentFolderId: parentFolderId, TrustUserId: trustUserId};
        let url = ConfigService.config.wAppsApi + 'api/v3/Folder';
        this.http.post(url, data).subscribe(result => {
            this.getFolders(this.parrentAttachmentFolderId);
        });
    }

    onUpload(){
        let modalConfig = new DwModalConfig();

        modalConfig.allowFullScreen = true;
        modalConfig.cloneData = false;
        modalConfig.modalSize = DwModalSize.responsive;
        modalConfig.data = {

        }
        modalConfig.component = UploadFileModalComponent;

        modalConfig.title = 'Upload File';
        modalConfig.buttons = DwModalButtonStandardConfigs.instance.SaveAndClose;

        this.dwModalService.showModal(modalConfig).subscribe(result => {
            if(!result.cancelled)
            {
                var file: FileList = result.data;

                file[0].arrayBuffer().then(data => {
                    this.uploadFile(this.selectedFolderId, file[0].name, this.trustUserId, data);
                })
            }
        });
    }

    uploadFile(folderId, name, trustUserId, data)
    {
        let url = ConfigService.config.wAppsApi + 'api/v3/file?trustUserId='+trustUserId+'&folderId='+folderId;
        var formData = new FormData();
        formData.append('files', new Blob([data]), name);
        this.http.post(url,formData).subscribe(results =>
            {
                this.getFiles(this.selectedFolderId);
            });
    }

    downloadFolderBtn(){

    }

    downloadFile(fileId, fileName)
    {
        let url = ConfigService.config.wAppsApi + 'api/v3/file?fileId='+fileId;
        this.http.get(url, {responseType: "blob"}).subscribe(results =>{
            saveAs(results,fileName);
        });
    }

    downloadFolder(folderId: number)
    {
        let url = ConfigService.config.wAppsApi + 'api/v3/folder?folderId='+folderId + '&download=true';
        this.http.get(url, {observe: 'response', responseType: "blob"}).subscribe(
            result => {
                saveAs(result.body, this.getFileNameFromHttpResponse(result.headers.get('Content-Disposition')));
            }
        );
    }

    onSearch(searchString : string){
        this.searchQuery = searchString;
    }

    folderSelected(folderId)
    {
        this.selectedFolderId = folderId;
        this.getFiles(folderId);
    }

    fileDblClicked(fileId: number, fileName:string)
    {
        this.downloadFile(fileId, fileName);
    }

    getFileNameFromHttpResponse(contentDispositionHeader) {
        var result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
        return result.replace(/"/g, '');
    }

    getParentFolderId()
    {
        const metaData = new AppMetaDataService();
        const queryHelper = new DwQueryHelper();

        const attachmentObjectQuery = metaData.AttachmentObject.CreateQuery();

        if(!this.attachmentObjectId)
        {
            //create attachment parent stuff;
        }
        attachmentObjectQuery.AddFilterAnd(queryHelper.filters.Equal(metaData.AttachmentObject.AttachmentObjectId, this.attachmentObjectId));
        const attachmentObjectObservable = this.dataService.executeQuerySingle(attachmentObjectQuery);
        var attachmentObjectResults = attachmentObjectObservable.subscribe(result => {
            var anyResult = result as any;
            this.parrentAttachmentFolderId = anyResult.ParentAttachmentFolderId;
        });
    }

}